import React from "react";
import clsx from "clsx";
import { getStatusColor, humanizeEnum } from "../../utils/helpers";

/** Colour-coded status pill driven by the backend enum value. */
export const StatusBadge: React.FC<{ status?: string | null; className?: string }> = ({
  status,
  className,
}) => (
  <span
    className={clsx(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
      getStatusColor(status),
      className,
    )}
  >
    {humanizeEnum(status)}
  </span>
);

/** Active / inactive pill for boolean account states. */
export const ActiveBadge: React.FC<{ active?: boolean }> = ({ active }) => (
  <span
    className={clsx(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
      active
        ? "bg-emerald-500/15 text-emerald-400 ring-1 ring-emerald-500/30"
        : "bg-slate-700 text-slate-400",
    )}
  >
    {active ? "Active" : "Inactive"}
  </span>
);
